import { httpsCallable } from 'firebase/functions';

import { functions } from '../firebase/config';

const recalculateCallable = httpsCallable(functions, 'recalculateMedicalTransportBillingFacts');

/**
 * Berechnet die Abrechnungsmerkmale einer Krankenfahrt neu aus dem
 * Fahrertracking. Nötig, wenn Track-Punkte erst nach dem automatischen
 * Einfrieren eingetroffen sind (Fahrer war längere Zeit offline) oder das
 * Qualitäts-Gate „Prüfen"/„Nicht verwertbar" gemeldet hat.
 *
 * Das Portal darf `medicalTransportBillingFacts` nicht direkt schreiben — die
 * Firestore-Rules sperren das Feld für alle Clients, weil es der Nachweis
 * gegenüber der Kasse ist.
 */
export const recalculateMedicalTransportBillingFacts = async (rideId) => {
  const result = await recalculateCallable({ rideId });
  return result.data || {};
};

const tariffPreviewCallable = httpsCallable(functions, 'calculateMedicalTariffPreview');

/**
 * Rechnet eine Beispielfahrt gegen einen Tarif durch — für den Testrechner im
 * Tab „Tarife" und die Erlösvorschau.
 *
 * Die Rechenlogik liegt bewusst nur in der Cloud Function: eine zweite
 * Implementierung im Portal wäre nach wenigen Vertragsänderungen abgedriftet,
 * und dann stünden zwei verschiedene Zahlen für dieselbe Fahrt im System.
 * `positionen` erlaubt das Rechnen mit noch ungespeicherten Formularwerten.
 */
export const calculateMedicalTariffPreview = async ({ tarifId, positionen, fahrt }) => {
  const result = await tariffPreviewCallable({ tarifId, positionen, fahrt });
  return result.data || {};
};
